/// <reference path="../_all.ts" />

module search {

  AllResultsDirective.$inject = [
    'pageMetaService',
    'anchorNavService',
    '$mdDialog',
    'libraryService',
    'partService',
  ];
  export function AllResultsDirective(
    pageMetaService: navigation.IPageMetaService,
    anchorNavService: navigation.IAnchorNavService,
    $mdDialog: ng.material.IDialogService,
    libraryService: library.ILibraryService,
    partService: part.IPartService
  ): ng.IDirective {

    return {
      restrict: 'AE',
      scope: {
        hit: '=',
        resultMeta: '=',
        resultObject: '@'
      },
      templateUrl: 'search/AllResultsDirective',
      link: function (scope: IAllResultsScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes) {

        scope.meta = pageMetaService.getPageMeta;

        scope.resultObject = {
          Title: "Type undefined",
          ID: "NaN",
          Rest: "Use 'getResultByType()'",
          Meta: "No metadata"
        }

        scope.getResultByType = function (hit) {
          var data = {
            "Document": {
              Title: getTitle(scope.meta('hl') == 'D', hit.titleD, hit.titleE),
              ID: hit.documentId,
              Rest: hit.attachment && hit.attachment.content_length > 0 ? hit.attachment.content : "",
              Meta: scope.resultMeta
            }
            , "Application": {
              Title: scope.meta('hl') == 'D' ? hit.nameD : hit.nameE,
              ID: hit.applicationId,
              Meta: scope.resultMeta
            }
            , "Industry": {
              Title: scope.meta('hl') == 'D' ? hit.nameD : hit.nameE,
              ID: hit.industryID,
              Meta: scope.resultMeta
            }
            , "Product": {
              Title: hit.name,
              ID: hit.id,
              Rest: scope.meta('hl') == 'D' ? hit.longDescD : hit.longDescD,
              Meta: scope.resultMeta
            }
            , "Part": {
              Title: scope.meta('hl') == 'D' ? hit.textD : hit.textE,
              ID: hit.partId,
              Meta: scope.resultMeta
            }
          };
          scope.resultObject = data[scope.resultMeta.Type];
        }

        scope.getImgUrl = function () {
          var data = {
            "Document": "/svc/docthumbnail.axd?RevId=" + scope.hit.fileSrcRevId,
          }
          return data[scope.resultMeta.Type];          
        }

        scope.capitalizeFirst = function (str: string) {
          if (str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
          } else {
            return "";
          }
        }

        var getTitle = function (de : boolean, titleD: string, titleE: string) : string {
          return  de ? (titleD || titleE)  : (titleE || titleD);          
        };


       scope.shortenText = function (text: string) {
          if (text) {
            var textArray = text.split('');
            if (textArray.length > 175) {
              var textString = textArray.slice(0, 175).join('');
              return textString;
            } else {
              return text;
            }
          } else {
            return '';
          }
        }

        scope.openDialog = function (ev: ng.IAngularEvent, hit: any) {
          if (scope.resultMeta.Type == "Document") {
            ev.preventDefault();
            libraryService.openDialog(hit["fileSrcRevId"], scope, null);
          } else if (scope.resultMeta.Type == "Part") {
            ev.preventDefault();
            partService.openDialog(hit["id"], scope);
          } else {
            return;
          }
        }

        scope.$watch('hit', function (newVal, oldVal) {
          if (newVal) {
            scope.getResultByType(newVal);
          }
        })

      }
    }

  }

}